<template>
  <div class="nveasy-bluetooth-progress">
    <div class="nveasy-bluetooth-progress__header">
      <span class="nveasy-bluetooth-progress__title">传输总览</span>
      <span v-if="isDownloading" class="nveasy-bluetooth-progress__text">{{ progressText }}</span>
    </div>
    <div v-if="isDownloading" class="nveasy-bluetooth-progress__bar">
      <div class="nveasy-bluetooth-progress__track">
        <span class="nveasy-bluetooth-progress__fill" :style="{ width: percentText }"></span>
      </div>
      <span class="nveasy-bluetooth-progress__percent">{{ percentText }}</span>
    </div>
    <div v-else class="nveasy-bluetooth-progress__nothing">暂无待传输录音</div>
    <!-- <p v-if="isUploading" class="nveasy-bluetooth-progress__desc">
      {{ uploadProgressText }}
    </p> -->
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  downloadProgress: {
    type: Object,
    default: () => ({}),
    required: true
  }
  // uploadProgress: {
  //   type: Object,
  //   default: () => ({}),
  //   required: true
  // }
})

const progressText = computed(() => {
  return `第 ${props.downloadProgress.currentCount} / ${props.downloadProgress.totalCount} 个`
})

const percent = computed(() => {
  const currentPacket = Number(props.downloadProgress.currentPacket) || 0
  const totalPackets = Number(props.downloadProgress.totalPackets) || 0
  if (!totalPackets) return 0
  return Math.min(Math.max(Math.round((currentPacket / totalPackets) * 100), 0), 100)
})

const percentText = computed(() => {
  return `${percent.value}%`
})

// const uploadProgressText = computed(() => {
//   const { successCount = 0, totalCount = 0, errorCount = 0 } = props.uploadProgress
//   return `上传中... 已上传 ${successCount} · 等待中 ${totalCount - successCount - errorCount} · 失败 ${errorCount}`
// })

const isDownloading = computed(() => props.downloadProgress.isPending)
// const isUploading = computed(() => props.uploadProgress.isPending)
</script>

<style lang="scss" scoped>
.nveasy-bluetooth-progress {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 12px;
  background: #f7f8fa;
  width: 100%;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    flex: 1;
    min-width: 0;
    color: #323233;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  &__text {
    flex-shrink: 0;
    margin-left: 4px;
    color: #969799;
    font-size: 12px;
    line-height: 16px;
  }

  &__bar {
    display: flex;
    align-items: center;
    margin-top: 4px;
  }

  &__track {
    position: relative;
    flex: 1;
    height: 6px;
    overflow: hidden;
    border-radius: 50px;
    background: #e5e6eb;
  }

  &__fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 50px;
    background: #7a52f4;
  }

  &__percent {
    flex-shrink: 0;
    width: 31px;
    margin-left: 8px;
    color: #646566;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: right;
  }

  &__desc {
    margin: 4px 0 0;
    color: #969799;
    font-size: 12px;
    line-height: 16px;
  }

  &__nothing {
    margin-top: 4px;
    color: #969799;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
